module.exports = __webpack_public_path__ + "img/grey-cardinal-4.83c41504.svg";